import axios from "axios";
import { api } from "../../../utils/api";
import { TOKEN } from "../../../utils/localStorage";
import { getCookie } from "cookies-next";

export const getDefectsListApi = async (data) => {
  return await api.get(
    `/defect-report/list?department_id=${data?.department_id}&category_defetct=${data?.category_defetct}&vessel_id=${data?.vessel_id}&defect_report_status=${data?.defect_report_status}&startDate=${data?.startDate}&endDate=${data?.endDate}&limit=${data?.limit}&offset=${data?.offset}`,
    {
      headers: {
        Authorization: `Bearer ${getCookie(TOKEN)}`,
      },
    }
  );
};

export const getDefectsDetailListApi = async (id) => {
  return await api.get(`/defect-report/${id}`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const updateDefectsDetailListApi = async (data) => {
  return await api.put(`/defect-report/update/${data?.id}`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const uploadFilesDefectsDetailListApi = async (data) => {
  return await api.post(`/utils/file/upload`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

// export const uploadFilesDefectsDetailDynamicApi = async ({ url, file }) => {
//   return await axios.get(url, file);
// };

export const uploadFilesDefectsDetailDynamicApi = async ({ url, file }) => {
  try {
    const response = await fetch(url, {
      method: 'PUT',
      body: file
    });

    return response;
  } catch (error) {
    // Handle any errors that may occur during the upload
    console.error("File upload failed:", error);
    throw error;
  }
};
